var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTourniquetSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_469)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 50,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.4219 28.0859V39.6422L56.1272 35.1172H51.8728L41.5781 39.6422V28.0859H24V71.9141H41.5781V60.8984H41.9475L52.6116 56.2109H55.3884L66.0525 60.8984H66.4219V71.9141H84V28.0859H66.4219ZM38.0625 68.3984H27.5156V64.8828H32.2031V61.3672H27.5156V57.8516H32.2031V54.3359H27.5156V50.8203H32.2031V47.3047H27.5156V31.6016H38.0625V68.3984ZM41.5781 57.2203V43.4933L52.2422 38.7953V52.5356L41.5781 57.2203ZM55.7578 52.5356V38.7953L66.4219 43.4801V57.2203L55.7578 52.5356ZM80.4844 68.3984H69.9375V31.6016H80.4844V68.3984Z",
    fill: "#8FB16A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9688 36.875C76.9688 37.8459 76.1819 38.6328 75.2109 38.6328C74.24 38.6328 73.4531 37.8459 73.4531 36.875C73.4531 35.9041 74.24 35.1172 75.2109 35.1172C76.1819 35.1172 76.9688 35.9041 76.9688 36.875ZM76.9688 43.9062C76.9688 44.8772 76.1819 45.6641 75.2109 45.6641C74.24 45.6641 73.4531 44.8772 73.4531 43.9062C73.4531 42.9353 74.24 42.1484 75.2109 42.1484C76.1819 42.1484 76.9688 42.9353 76.9688 43.9062Z",
    fill: "#8FB16A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_469",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.694118 0 0 0 0 0.415686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_469"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_469",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(24 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourniquetSystem);
export default __webpack_public_path__ + "static/media/tourniquetSystem.037f556dd2087a78fc82b35e48027547.svg";
export { ForwardRef as ReactComponent };